import { Dispatch, SetStateAction } from "react";
import { UseFormRegister } from "react-hook-form";
import { LoadingPage } from "../../../../shared/components/LoadingPage";
import { Botijao } from "../../types/Botijao";

interface BotijaoModalProps {
  botijao?: Botijao
  visualizar?: boolean
  inputDisabled?: boolean
  register: UseFormRegister<any>
  setInputDisabled?: Dispatch<SetStateAction<boolean>>
}

export function FormBotijao({
  inputDisabled,
  visualizar,
  botijao,
  register
} : BotijaoModalProps) {
  return (
    <form className="flex flex-row flex-wrap items-center">
      {
        visualizar && !botijao ? <LoadingPage /> :
        <div className="w-40%">
          <label className=" w-full font-[500]" htmlFor="Nome">Nome do Botijão</label>
          <input 
            type="text"
            {...register("Nome")}
            defaultValue={botijao?.Nome}
            disabled={inputDisabled}
            name="Nome"
            className="input-login-style w-full mt-2 mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
      }
    </form>
  );
}
